import dynamic from 'next/dynamic';

import FlightSearchBarContainer from '@components/views/flight/listing/SearchBar/next/FlightSearchBarContainer';
import { SearchBarViewModel } from '@api/index';
import { useDevice } from '@contexts/device';

import { Banner, Element, Title } from './styled';

const MobileSearchBar = dynamic(() => import('./MobileSearchBar'));

type Props = {
  data: SearchBarViewModel;
  showIsCheckbox?: boolean;
  isFlightTicketPage?: boolean;
  isHoliday?: boolean;
};

const SearchBar = ({
  data,
  showIsCheckbox,
  isFlightTicketPage,
  isHoliday,
}: Props) => {
  const { isDesktop } = useDevice();

  return isDesktop ? (
    <Banner url={data?.images?.[0]?.url}>
      <Title>{data?.name}</Title>
      <Element>
        <FlightSearchBarContainer
          showIsCheckbox={showIsCheckbox}
          isHoliday={isHoliday}
        />
      </Element>
    </Banner>
  ) : (
    <MobileSearchBar
      isFlightTicketPage={isFlightTicketPage}
      isHoliday={isHoliday}
    />
  );
};

export default SearchBar;
